import React, { FunctionComponent, useState } from "react";
import { StyleSheet, ScrollView } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";

import Container from "../../components/Container";
import Header from "../../components/Header";
import ProcedureLocationList from "../../components/ProcedureLocationList";
import { colors } from "../../theme";
import { ServiceType, ServiceTypeCategory, Store } from "../../types";
import { filterCategories } from "../../utils/service";

// How long the selected-card highlight shows before advancing -- long
// enough to read as "your tap registered", short enough not to feel
// like a stall.
const AUTO_ADVANCE_DELAY_MS = 350;

const styles = StyleSheet.create({
  container: {
    backgroundColor: colors.black,
    flex: 1,
  },
  scrollView: {
    paddingHorizontal: 20,
    paddingBottom: 30,
    flex: 1,
  },
});

type RouteParams = {
  store: Store;
  serviceType: ServiceType;
};

interface Props {
  route: any;
  navigation: any;
}

const ServiceCategorySelectionForVisitScreen: FunctionComponent<Props> = ({
  route,
  navigation,
}) => {
  const { serviceType }: RouteParams = route.params;

  const [
    selectedServiceTypeCategory,
    setSelectedServiceTypeCategory,
  ] = useState<ServiceTypeCategory | null>(null);

  // Auto-advances on selection instead of requiring a separate Next tap
  // right below the just-selected card -- that tight tap-then-tap
  // sequence was the exact window where iOS Safari could miss the
  // second tap (see [[project-ios-safari-double-tap]] in memory).
  const handleSelect = (category: ServiceTypeCategory) => {
    setSelectedServiceTypeCategory(category);
    setTimeout(() => {
      navigation.navigate("ServiceSelectionForVisit", {
        serviceType,
        serviceTypeCategory: category,
      });
    }, AUTO_ADVANCE_DELAY_MS);
  };

  return (
    <SafeAreaView style={styles.container} edges={["right", "bottom", "left"]}>
      <Container>
        <ScrollView style={styles.scrollView}>
          <Header
            title={`${serviceType?.name} Location`}
            description={`Start by selecting the location for your ${serviceType?.name}.`}
          />
          {serviceType?.categories && (
            <ProcedureLocationList
              serviceType={serviceType}
              locations={filterCategories(serviceType?.categories)}
              selectedLocation={selectedServiceTypeCategory}
              onSelect={handleSelect}
            />
          )}
        </ScrollView>
      </Container>
    </SafeAreaView>
  );
};

export default ServiceCategorySelectionForVisitScreen;
